import { render, staticRenderFns } from "./EventListAddNew.vue?vue&type=template&id=7322e19c&"
import script from "./EventListAddNew.vue?vue&type=script&lang=js&"
export * from "./EventListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports